// "Mehtap Müjde" → "MM", "Dr. Ayşe" → "DA", boş → "". Avatar görseli olmayan
// karşı taraf için baş harf rozeti; iki kelimeden fazlası alınmaz.
export function nameInitials(name) {
  if (!name) return '';

  return String(name)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part.charAt(0))
    .join('')
    .toLocaleUpperCase('tr-TR');
}

export default nameInitials;
